export interface Word { id: string; answer: string; aliases: string[]; category: string; difficulty: number }
export interface Choice { id: string; text: string; category: string; reward: number }
export const CHOICE_REFRESH = { free: 2, cost: 1 } as const;
export const normalizeAnswer = (text: string) => text.normalize('NFKC').trim().toLocaleLowerCase('en-US').replace(/\s+/g, ' ');
